import React, {Component} from 'react';
import i18n from '../../i18n';
import config from '../../config';
import {withTranslation} from 'react-i18next';
import {Loading, NotFoundError, SubHeading, withRouter} from "cw-styleguide-react";
import {GelContentContainer} from "cw-styleguide-react";
import {HeroBlock, StyleguideContext, HandleLoading, FormUtility} from "cw-styleguide-react";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import axios from "axios";
import NewsDetailView from "./NewsDetailView";

class NewsDetailController extends Component {
  constructor(props) {
    super(props);

    this.state = {
      news: null,
      loaded:null,
      messages: new Set()
    };
  }

  getData(alias) {
    axios.get(config.endpoints.news[i18n.language] + '/' + alias, {
      params: {
        time: Date.now()
      }
    })
    .then(response => {


      this.setState({
        news: response.data,
        loaded:true
      });

      if (response.data.translated) {
        this.context.setLanguageUrl(response.data.translatedAlias);
      }
      else {
        this.context.setLanguageUrl('');
      }
    })
    .catch(error => {


      let errors = FormUtility.processServerErrors(error, i18n);

      if (error.response.status == 404) {
        this.setState({
          loaded: error.response.status
        })
      } else {
        this.setState({
          messages: errors.messages,
          loaded: false
        })
      }
    });
  }

  componentDidMount() {
    console.log(this.props.params);

    this.getData(this.props.params.alias);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      typeof window.initialiseAccordion === 'function' &&
      typeof window.initialiseDocumentDownload === 'function' &&
      typeof window.initialiseCardInfographic === 'function' &&
      typeof window.initialiseShowMoreLess === 'function' &&
      typeof window.initialiseAnchor === 'function'
    ) {
      window.initialiseAccordion(this.props.t('styleguide:expand_all'), this.props.t('styleguide:collapse_all'));
      window.initialiseDocumentDownload();
      window.initialiseCardInfographic();
      window.initialiseShowMoreLess(this.props.t('styleguide:show_more'), this.props.t('styleguide:show_less'), this.props.t('styleguide:expand_all'), this.props.t('styleguide:close_all'));
      window.initialiseAnchor(this.props.t('styleguide:document_email_link'), this.props.t('styleguide:opens_email_client'), this.props.t('styleguide:link_to'), this.props.t('styleguide:external_website'));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.alias !== nextProps.params.alias) {
      this.setState({news: null});
      this.getData(nextProps.match.params.alias);
    }
  }

  render() {


    return (
        <HandleLoading loading={{loaded:this.state.loaded}} messages={this.state.messages} container={true} domain={config.domain}>
            <NewsDetailView {...this.state} />
        </HandleLoading>
    );
  }
}

NewsDetailController.contextType = StyleguideContext;
export default withTranslation('remote')(withRouter(NewsDetailController));